<script>
    import { fade } from 'svelte/transition';
    import Spinner from 'svelte-spinner';
</script>
<style>
.Loading-spinner {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}
</style>

<div class="Loading-spinner" transition:fade="{{duration:100}}">
<Spinner
  size="70"
  speed="600"
  color="#FDE509"
  thickness="3"
  gap="40"
/>
</div>